import React from "react";

const CreateLeadVisaForm = ({
  mode,
  formData,
  setFormData,
  handleChange,
  sectionsRef,
}) => {
  const handleChangeCountry = (e) => {
    const { value, type } = e.target;

    setFormData((prevState) => {
      let selectedCountries = Array.isArray(prevState.visa_country_name)
        ? [...prevState.visa_country_name]
        : [];

      if (type === "checkbox") {
        if (selectedCountries.includes(value)) {
          selectedCountries = selectedCountries.filter(
            (country) => country !== value
          );
        } else {
          selectedCountries.push(value);
        }
        return { ...prevState, visa_country_name: selectedCountries };
      } else {
        return { ...prevState, other_country_visa: value };
      }
    });
  };

  return (
    <div
      className="p-6 border-b-2 border-gray-300 space-y-8"
      ref={sectionsRef.visa}
      id="visa"
    >
      <div className="p-2 space-y-2">
        <h2 className="text-lg font-semibold text-purple-700 mb-4">
          Visa Details
        </h2>

        {/* Visa Country Selection */}
        <div className="flex justify-between">
          <label htmlFor="visa_country_name" className="font-semibold">
            Intended Countries (Multiple select)*
          </label>
          <div className="flex flex-col w-1/2">
            {[
              "USA",
              "UK",
              "Australia",
              "Canada",
              "Germany",
              "India",
              "Ireland",
              "Newzealand",
              "Others",
            ].map((country) => (
              <label key={country} className="flex items-center">
                <input
                  type="checkbox"
                  value={country}
                  onChange={handleChangeCountry}
                  checked={
                    formData.visa_country_name &&
                    formData.visa_country_name.includes(country)
                  }
                  disabled={mode === "view"}
                  className="mr-2"
                />
                {country}
              </label>
            ))}
          </div>
        </div>

        {/* Other Countries for Abroad Studies */}
        {formData.visa_country_name &&
          formData.visa_country_name.includes("Others") && (
            <div className="flex justify-between">
              <label htmlFor="other_country_visa" className="font-semibold">
                Other Countries For Abroad studies (If Applicable)
              </label>
              <input
                type="text"
                name="other_country_visa"
                value={formData.other_country_visa}
                onChange={handleChange}
                className="border rounded-lg p-2 mt-1 w-1/2"
                disabled={mode === "view"}
              />
            </div>
          )}
      </div>
    </div>
  );
};

export default CreateLeadVisaForm;
